<template>
  <input-widget
      v-if="isSelect2" :model="model" :attribute="attribute" type="select2" display-field="${item.name}"
      :items="select2Items">
  </input-widget>
  <div v-else-if="isSalesTaxEnabled && stateUuid" class="typeahead">
    <input-widget
        :model="model" :attribute="attribute" @keyup="onKeyup" @input="getCounties" @blur="onBlur"
        @mousedown="onMousedown" @keydown.down="onArrowKeyDown" @keydown.up="onArrowKeyUp" @keydown.esc="resetInfo"
        @keydown.enter="onCountySelect">
    </input-widget>
    <div class="results-ctr" tabindex="0" @mousedown="isFocused=true" @blur="isFocused=false">
      <ul class="result-list shadow" v-show="isOpen">
        <li v-for="(item, index) in items" class="py-1 px-3" :class="{'active': index === activeIndex}" :key="item.uuid"
            @mousemove="setActive(index)" @mousedown="onCountySelect">
          {{ item.name }}
        </li>
      </ul>
    </div>
  </div>
  <input-widget v-else :model="model" :attribute="attribute"/>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import InputWidget from "../components/input-widget/InputWidget";
  import _ from "lodash";
  import {GeographicStructureHelper} from "../services/geographicStructureHelper";

  const {mapState} = createNamespacedHelpers('global');

  export default {
    name: "CountyInputWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      stateUuid: {
        type: String,
      },
      objectUuidName: {
        type: String,
        default: '',
      },
      isSelect2: {
        type: Boolean,
        default: false
      },
      select2Items: {
        type: Array,
        default: () => []
      },
      enableStateUuidWatcher: {
        type: Boolean,
        default: true
      },
    },
    data() {
      return {
        items: [],
        open: false,
        activeIndex: 0,
        isFocused: false,
      }
    },
    computed: {
      ...mapState(['isSalesTaxEnabled']),
      hasItems() {
        return this.items.length;
      },
      isOpen() {
        return this.model[this.attribute] && (this.open || this.isFocused) && this.hasItems;
      },
    },
    watch: {
      stateUuid() {
        if (this.enableStateUuidWatcher) {
          this.clearData();
        }
      },
    },
    methods: {
      onKeyup($event) {
        this.$emit('keyup', $event);
      },
      onBlur($event) {
        this.open = false;
        this.$emit('blur', $event);
      },
      onMousedown($event) {
        if (this.items.length) {
          this.open = true;
        }
        this.$emit('mousedown', $event);
      },
      onArrowKeyDown() {
        this.activeIndex++;
        if (this.activeIndex > this.items.length) {
          this.activeIndex = 0;
        }
      },
      onArrowKeyUp() {
        this.activeIndex--;
        if (this.activeIndex < 0) {
          this.activeIndex = this.items.length;
        }
      },
      resetInfo() {
        this.open = false;
        this.isFocused = false;
        this.activeIndex = 0;
      },
      setActive(index) {
        this.activeIndex = index;
      },
      clearData() {
        this.items = [];
        if (this.objectUuidName) {
          this.model[this.objectUuidName] = null;
        }
      },
      getCounties: _.debounce(async function (value) {
        if (this.objectUuidName) {
          this.model[this.objectUuidName] = null;
        }
        const {success, body} = await GeographicStructureHelper.getCountiesByState({
          load_all: true,
          state_uuid: this.stateUuid,
          county_name: value.trim()
        });
        if (success) {
          this.items = _.cloneDeep(body || []);
          this.open = true;
        }
      }, 500),
      onCountySelect($event) {
        $event.preventDefault();
        const value = this.items[this.activeIndex];
        if (value) {
          this.model[this.attribute] = value.name;
          if (this.objectUuidName) {
            this.model[this.objectUuidName] = value.uuid;
          }
        }
        setTimeout(() => {
          this.resetInfo();
        })
      },
    },
  }
</script>


<style lang="scss" scoped>
  .typeahead {
    position: relative;
  }

  .results-ctr {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 3;
    background: white;
  }

  .result-list {
    max-height: 160px;
    overflow: auto;
    list-style: none;
    padding: 0;

    > li {
      padding: 16px 32px;

      &.active {
        background-color: #03a9f4;
        color: white;
      }
    }
  }
</style>